import styled from 'styled-components';
import { Button } from '../../../../Components/uielements';
import { palette } from 'styled-theme';

export const CattleNvdWrapper = styled.div`
  min-height: 100vh;
  padding: 20px;
  font-family: 'Space Grotesk Regular', sans-serif;
  color: #ffffff;
  background: #ffd700;
  border-radius: 4px;

  .form-content {
    max-width: 900px;
    margin: 0 auto;
    background: #181a3b;
    border-radius: 4px;
    padding: 30px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
`;

export const FormSection = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 30px;
  margin-bottom: 25px;
  background: #181a3b;

  .section-title {
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    margin: 0 0 15px 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .section-subtitle {
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .subsection {
    margin: 25px 0;
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    background: #181a3b; /* Dark subsection background */
  }

  .subsection-title {
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    margin: 0 0 15px 0;
  }

  &.part-a-section {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: #181a3b;
  }
`;

export const FormHeader = styled.div`
  text-align: center;
`;

export const FormTopHeader = styled.div`
  text-align: center;
  background: #181a3b;
  border-radius: 4px;
  padding: 30px;
  margin-bottom: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const FormTitle = styled.h1`
  font-family: 'Space Grotesk Regular', sans-serif;
  font-size: 26px;
  font-weight: 700;
  font-style: normal;
  margin: 0 0 10px 0;

  .subtitle {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    margin-top: 8px;
  }
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 20px 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;

  &.full-width {
    grid-column: 1 / -1;
  }

  label {
    color: rgba(255, 255, 255, 0.9);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    margin-bottom: 6px;
    display: block;
  }

  input,
  select,
  textarea {
    background: #181a3b; /* Dark input background */
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    padding: 14px 16px;
    color: #ffffff;
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    width: 100%;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: rgba(0, 255, 136, 0.4);
    }

    &:hover {
      border-color: rgba(0, 255, 136, 0.4);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
      font-style: normal;
    }
  }

  select {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%2300ff88' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
    background-position: right 16px center;
    background-repeat: no-repeat;
    background-size: 16px;
    padding-right: 45px;

    option {
      background: #181a3b; /* Dark option background */
      color: #ffffff;
      font-family: 'Space Grotesk Regular', sans-serif;
      font-style: normal;
      padding: 10px;
    }
  }

  textarea {
    resize: vertical;
    min-height: 100px;
    line-height: 1.5;
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  margin: 20px 0;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #181a3b; /* Dark table background */
`;

export const CattleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Space Grotesk Regular', sans-serif;
  background: #181a3b; /* Dark table background */

  thead {
    th {
      padding: 16px 12px;
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      font-style: normal;
      background: #181a3b;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      white-space: nowrap;

      &:not(:last-child) {
        border-right: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      background: #181a3b;

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      padding: 12px;
      border-right: 1px solid rgba(255, 255, 255, 0.05);
      background: #181a3b;

      &:last-child {
        border-right: none;
        text-align: center;
      }

      input {
        background: #181a3b; /* Dark input background in table */
        border: 1px solid rgba(255, 255, 255, 0.15);
        border-radius: 4px;
        padding: 10px 12px;
        color: #ffffff;
        font-family: 'Space Grotesk Regular', sans-serif;
        font-size: 13px;
        font-style: normal;
        width: 100%;
        box-sizing: border-box;

        &:focus {
          outline: none;
          border-color: rgba(0, 255, 136, 0.2);
        }

        &::placeholder {
          color: rgba(255, 255, 255, 0.4);
          font-style: normal;
        }
      }
    }
  }
`;

export const QuestionGroup = styled.div`
  background: #181a3b; /* Dark question background */
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 25px;
  margin: 20px 0;

  &:hover {
    border-color: rgba(0, 255, 136, 0.2);
    background: #181a3b;
  }
`;

export const QuestionLabel = styled.label`
  color: rgba(255, 255, 255, 0.9);
  font-family: 'Space Grotesk Regular', sans-serif;
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  line-height: 1.6;
  display: block;
  margin-bottom: 15px;

  br {
    margin: 5px 0;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 30px;
  margin-top: 15px;

  .radio-option {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 4px;
    background: #181a3b; /* Dark radio option background */
    border: 1px solid rgba(255, 255, 255, 0.1);

    &:hover {
      background: #181a3b;
      border-color: rgba(0, 255, 136, 0.2);
    }

    input[type='radio'] {
      width: 18px;
      height: 18px;
      accent-color: #00ff88;
      cursor: pointer;
      margin: 0;
    }

    .radio-label {
      color: rgba(255, 255, 255, 0.9);
      font-family: 'Space Grotesk Regular', sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      cursor: pointer;
      user-select: none;
    }

    &:has(input:checked) {
      background: rgba(0, 255, 136, 0.1);
      border-color: #00ff88;

      .radio-label {
      }
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const CheckboxGroup = styled.div`
  background: #181a3b; /* Dark checkbox background */
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 25px;
  margin: 20px 0;

  label {
    color: rgba(255, 255, 255, 0.9);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 15px;
    font-weight: 500;
    font-style: normal;
    line-height: 1.6;
    display: block;
    margin-bottom: 15px;
  }
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 10px 0;
  padding: 8px 0;

  input[type='radio'],
  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    accent-color: #00ff88;
    cursor: pointer;
  }

  span {
    color: rgba(255, 255, 255, 0.9);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    cursor: pointer;
    user-select: none;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding: 20px 0;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px;

    button {
      width: 100%;
    }
  }
`;

export const FormButton = styled(Button)`
  max-width: fit-content;
`;

export const OutlineButton = styled(Button)`
  border: 1.5px solid ${palette('background', 0)} !important;
  background: ${palette('background', 0)} !important;
  color: ${palette('text', 1)} !important;
  max-width: fit-content;
  &:hover,
  :focus {
    background: ${palette('background', 0)} !important;
    color: ${palette('text', 1)} !important;
    border: none !important;
  }
`;

export const DeclarationContainer = styled.div`
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.08) 0%, rgba(0, 255, 136, 0.03) 100%);
  border: 1px solid rgba(0, 255, 136, 0.25);
  border-radius: 4px;
  padding: 25px;
  margin: 25px 0;

  .declaration-text {
    margin-bottom: 20px;

    h4 {
      font-family: 'Space Grotesk Regular', sans-serif;
      font-size: 16px;
      font-weight: 600;
      font-style: normal;
      margin: 0 0 15px 0;
    }

    p {
      color: rgba(255, 255, 255, 0.85);
      font-family: 'Space Grotesk Regular', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.7;
      margin: 0;
      background: rgba(255, 255, 255, 0.03);
      padding: 20px;
      border-radius: 4px;
      border-left: 4px solid #00ff88;
    }
  }
`;

export const DeclarationText = styled.div`
  background: rgba(0, 255, 136, 0.05);
  border: 1px solid rgba(0, 255, 136, 0.2);
  border-radius: 4px;
  padding: 20px;
  margin: 20px 0;

  p {
    color: rgba(255, 255, 255, 0.85);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.7;
    margin: 0;
  }
`;

// Simple step header component
export const StepHeader = styled.div`
  background: rgba(0, 255, 136, 0.05);
  border: 1px solid rgba(0, 255, 136, 0.2);
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 30px;
  text-align: center;

  h2 {
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 22px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }

  .step-info {
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Space Grotesk Regular', sans-serif;
    font-size: 14px;
    margin: 0;
  }
`;

export const ErrorMessage = styled.div`
  background: rgba(255, 71, 87, 0.1);
  border: 1px solid rgba(255, 71, 87, 0.3);
  border-radius: 4px;
  padding: 15px;
  margin: 15px 0;
  color: #ff4757;
  font-family: 'Space Grotesk Regular', sans-serif;
  font-size: 14px;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 10px;

  .error-icon {
    font-size: 18px;
  }
`;

export const SuccessMessage = styled.div`
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  border-radius: 4px;
  padding: 15px;
  margin: 15px 0;

  font-family: 'Space Grotesk Regular', sans-serif;
  font-size: 14px;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 10px;

  .success-icon {
    font-size: 18px;
  }
`;

export const ValidationWrapper = styled.div`
  .field-error {
    input,
    select,
    textarea {
      border-color: #ff4757 !important;
    }
  }

  .field-success {
    input,
    select,
    textarea {
      border-color: #00ff88 !important;
    }
  }

  .validation-message {
    font-size: 12px;
    margin-top: 5px;
    font-family: 'Space Grotesk Regular', sans-serif;
    font-style: normal;

    &.error {
      color: #ff4757;
    }

    &.success {
    }
  }
`;
